<template>
  <div class="col">
    <div class="r-product" :class="{ selected: isActive }">
      <div class="inner">
        <img class="brand-logo" :src="line.brand_logo" alt="brand_logo" />
        <img class="product-img" :src="line.image" alt="product_img" />
        <div
          v-if="line.ral_number"
          class="ral"
          :style="{
            'background-color': line.ral_hex,
            color: line.text_color,
          }"
        >
          <div>RAL {{ line.ral_number }}</div>
        </div>

        <div class="info">
          <h5 class="title">{{ line.name }}</h5>
          <span class="oldPrice" v-if="hasDiscount">
            {{ formatPrice(vatPrice(line.total_price / 100)) }}
          </span>
          <span class="price">
            {{ formatPrice(vatPrice(calculateTotalPrice(line) / 100)) }}
          </span>
        </div>
        <div v-if="isActive" class="selected-mark">
          <span>geselecteerd</span>
          <img :src="getIcon('checkmark-circle.svg')" alt="checkmark" />
        </div>
      </div>
      <button
        v-if="getRooms.length > 1 && !allRoomsSelected"
        @click="onNextStep"
        class="emat-btn emat-btn-next"
      >
        Selecteer
      </button>
      <ButtonNext
        v-else
        :is-success="true"
        :line-id="line.id"
        @nextStep="onNextStep"
      />
    </div>
  </div>
</template>

<script>
import ButtonNext from '../utilities/ButtonNext';
import { mapActions, mapGetters, mapMutations } from 'vuex';

export default {
  name: 'LineResultsProduct',
  components: {
    ButtonNext,
  },
  props: {
    line: {
      type: Object,
      default: () => ({}),
    },
  },
  computed: {
    ...mapGetters({
      getDiscount: 'discount/calculateTotalPriceWithDiscount',
    }),
    ...mapGetters('build', [
      'getRooms',
      'getSelectedLine',
      'getAllSelectedLines',
    ]),
    ...mapGetters('brand-color-selection', ['allRoomsSelected']),
    hasDiscount() {
      return this.calculateTotalPrice(this.line) !== this.line.total_price;
    },
    isActive() {
      if (this.getRooms.length === 0) {
        return false;
      }

      if (this.allRoomsSelected) {
        // Check if any room has no line or not all rooms have the same line
        const allSelectedLines = this.getAllSelectedLines;
        const baseLine = allSelectedLines[0];
        const isValid = allSelectedLines.every(
          (line) => line && line.id === baseLine?.id
        );

        return isValid && baseLine?.id === this.line.id;
      }

      return this.getSelectedLine && this.getSelectedLine.id === this.line.id;
    },
  },
  methods: {
    ...mapActions('step', ['goToStepFinishOrder']),
    ...mapActions('build', ['updateLine']),
    ...mapGetters('build', {
      activeRoom: 'getActiveRoom',
    }),
    calculateTotalPrice(line) {
      return this.getDiscount(line.product_price_data);
    },
    onNextStep() {
      this.updateLine(this.line);

      if (this.allRoomsSelected) {
        this.$store.dispatch('build/makeAllRooms');
      } else {
        this.$store.dispatch('build/makeRoom', this.activeRoom().id);
      }

      if (
        this.allRoomsSelected ||
        (this.getRooms.length < 2 && !this.allRoomsSelected)
      ) {
        this.goToStepFinishOrder();
      }
    },
  },
};
</script>
